const workerNames = [
    {
        value: 'AppointmentsWorker',
        label: 'Appointments'
    }
]

export default workerNames